import { useState } from 'react';
import "./Inquirydesk.scss";
import StudentsAndParents from "../Students And Parents/StudentsAndParents.jsx";
import Visitors from '../Visitors/Visitors.jsx';
import Header from '../../Shared-Component/Header/Header.jsx';
import Footer from '../../Shared-Component/Footer/Footer.jsx';

const HelpDesk = () => {
    const [toggleFormPage, setToggleFormPage] = useState("studentsAndParents");

    return (
        <>
                       <div className="header">
                <Header />
            </div>

                       <div className="main-container">
                <section className="helpDeskMainContainer">
                    <header>
                        <h2>Inquiry Desk</h2>
                        <div>
                            <p>Submit the form given below for the Enquiry about Grievances, Academic, and Admission.</p>
                            <p>Contact: Dr. S. Kala, 9489821025</p>
                        </div>
                    </header>
                    <div className="helpDeskFormMainContainer">
                                               <div className="firstSection">
                            <span className={toggleFormPage === "studentsAndParents" ? "activeTab" : ""} >
                                <button
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setToggleFormPage("studentsAndParents")}
                                >
                                    Students & Parents
                                </button>
                            </span>
                            <span className={toggleFormPage === "visitors" ? "activeTab" : ""} style={{ cursor: "pointer" }}>
                                <button
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setToggleFormPage("visitors")}
                                >
                                    Visitors
                                </button>
                            </span>
                        </div>

                                              <div className="secondSection">
                            {toggleFormPage === "studentsAndParents" ?
                                (<StudentsAndParents />) :
                                (<Visitors />)
                            }
                        </div>
                    </div>
                </section>
            </div>


            {/* Footer */}
            <div>
                <Footer />
            </div>
        </>
    )
}

export default HelpDesk
